import AppStore from '@v4/store/appStore'
import { useCallback, useEffect } from 'react'
import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import Tracking from '@v4/utils/tracking'
import { TrackingEvents } from '@v4/constants/tracking'

export const useSingUpLanding = ({ metaData }) => {
	const sectionId = useSectionId()
	const activeSectionId = PageBuilderSelector.useActiveSectionId()
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const { setActiveSectionId } = PageBuilderSelector.useActions()

	const handleClose = useCallback(
		event => {
			event.preventDefault()
			event.stopPropagation()
			setActiveSectionId({ id: null })
		},
		[setActiveSectionId],
	)

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonText })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const open = sectionId === activeSectionId

	useEffect(() => {
		if (!isBuilderMode && open) {
			Tracking.track(TrackingEvents.LEAD_FORM_MODAL_OPENED)
		}
	}, [isBuilderMode, open])

	return [
		{
			open,
			placeholderColor: metaData.placeholderColor?.metaValue,
			buttonText: metaData.buttonText?.metaValue,
			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleEditable,
			buttonTextEditable,
			buttonTextConfig: metaData.buttonText?.config,
			titleKey: metaData.title?.tierKey,
			buttonTextKey: metaData.buttonText?.tierKey,
		},
		{
			handleClose,
			handleTitleClick,
			handleButtonClick,
			handleTitleChange,
			handleButtonTextChange,
		},
	]
}
